import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "triple-select mr-2" }



import RegionComponent from "../region/regionComponent.vue";
import CountryComponent from "../country/countryComponent.vue";
import PostalcodeComponent from "../postalcode/postalcodeComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'locationComponent',
  props: {
    country: {},
    postal_code: {},
    region: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CountryComponent, {
        error: props?.country
      }, null, 8, ["error"]),
      _createVNode(PostalcodeComponent, {
        error: props?.postal_code
      }, null, 8, ["error"]),
      _createVNode(RegionComponent, {
        error: props?.region
      }, null, 8, ["error"])
    ])
  ]))
}
}

})